import type { JSX } from 'react'
import type { IActionButtonProps } from '../ActionButton'

import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonIconSizes,
  IconPositions,
} from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { ActionButton } from '../ActionButton'

export interface ISecondaryOpacityWithAngleProps extends IActionButtonProps {}

export const SecondaryOpacityWithAngle = ({
  title = '',
  icon = IconNames.angleDown,
  iconPosition = IconPositions.Right,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  paddings = [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_60,
  ],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_15,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_LIGHT_20,
  backgroundColorDisabled = COLOR.DISABLED,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font,
  fluid = ButtonFluid.None,
  ...rest
}: ISecondaryOpacityWithAngleProps): JSX.Element | null =>
  title ? (
    <ActionButton
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      title={title}
      {...rest}
    />
  ) : null
